// @flow
import React from 'react';
import Box from 'components/Box';

const Hide = ({
  xs,
  sm,
  md,
  lg,
  xl,
  xsmall,
  small,
  medium,
  large,
  xlarge,
  display, // eslint-disable-line no-shadow
  ...props
}: {
  xs?: boolean,
  sm?: boolean,
  md?: boolean,
  lg?: boolean,
  xl?: boolean,
  xsmall?: boolean,
  small?: boolean,
  medium?: boolean,
  large?: boolean,
  xlarge?: boolean,
  display?: string
}) => (
  <Box
    {...props}
    display={[xs, sm, md, lg, xl].map(n => (n ? 'none' : display || 'block'))}
  />
);

export default Hide;
